module.exports = __webpack_public_path__ + "static/media/11.f3374bad.jpg";